<template>
    <div class="margin-20">
        <div class="page-container">
            <FilterPageList ref="pageListRef" :get-data="getJobMessageHistory" :total="total" :order-by="orderBy" :filters="filters" v-loading="tableLoading" element-loading-text="请稍等···">
                <template slot-scope="scope">
                    <el-form :inline="true" class="table-filter">
                        <el-form-item label="">
                            <el-select style="width: 140px;" v-model="filters.messageResult.value" @change="scope.search">
                                <el-option label="全部状态" value=""></el-option>
                                <el-option v-for="item in messageResults" :label="item.label" :value="item.value" :key="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="">
                            <el-input :placeholder="filterColumnPlaceholder" v-model.trim="filters[selectColumn].value" >
                              <el-select style="width: 120px;" slot="prepend" v-model="selectColumn" @change="selectColumnChange">
                                  <el-option label="AppKey" value="appKey"></el-option>
                                  <el-option label="站点ID" value="siteId"></el-option>
                                  <el-option label="主题" value="topic"></el-option>
                              </el-select>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="scope.search">查询</el-button>
                            <el-button type="primary" icon="fa fa-repeat" @click="resetMessageResult();scope.search()">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="page-table" v-loading="loading" element-loading-text="请稍等···">
                        <div class="page-table-header">
                            <div class="page-table-header-title"><i class="fa fa-list"></i>作业消息日志列表
                                <el-button type="text" @click="scope.search"><i class="fa fa-refresh"></i></el-button>
                            </div>
                            <div class="page-table-header-separator"></div>
                            <div>
                                <el-button @click="batchDelete()" v-if="$common.hasPerm('job:batchRemove', domainName)"><i class="fa fa-trash text-danger"></i>删除</el-button>
                            </div>
                            <div class="pull-right">
                                <!--<el-button @click="handleAdd()" v-if="$common.hasPerm('job:add', domainName)"><i class="fa fa-plus-circle text-btn"></i>添加</el-button>-->
                            </div>
                        </div>
                        <el-table stripe border ref="multipleTable" @selection-change="handleSelectionChange" :data="JobMessageHistoryList" @sort-change="scope.onSortChange" style="width: 100%">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="appKey" label="AppKey" sortable="custom" width="100px">
                                <template slot-scope="scope">
                                    {{scope.row.appKey}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="siteId" label="站点ID" width="100px">
                                <template slot-scope="scope">
                                    {{scope.row.siteId}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="topic" label="主题" width="100px">
                                <template slot-scope="scope">
                                    {{scope.row.topic}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="userIds" label="接收用户" width="120px">
                                <template slot-scope="scope">
                                    {{scope.row.userIds}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="userTypes" label="接收用户类型" width="120px">
                                <template slot-scope="scope">
                                    {{scope.row.userTypes}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="msgBody" show-overflow-tooltip label="消息内容">
                                <template slot-scope="scope">
                                    {{scope.row.msgBody}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="execTime" label="执行耗时 秒" width="100px">
                                <template slot-scope="scope">
                                    {{scope.row.execTime}}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" prop="messageResult" width="90px">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.messageResult === true ? 'success' : 'warning'" close-transition>{{translateMessageResult[scope.row.messageResult]}}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="消息发送时间" prop="createTime" width="160px">
                                <template slot-scope="scope">
                                    {{scope.row.createTime | formatDate}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="messageResultReason" show-overflow-tooltip label="失败原因">
                                <template slot-scope="scope"> 
                                    {{scope.row.messageResultReason}}
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="120px" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip content="删除" placement="top" >
                                        <el-button type="text" icon="el-icon-delete text-danger" @click="handleDelete(scope.row)"></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </template>
            </FilterPageList>
        </div>
    </div>
</template>

<script>


export default {
  data() {
    return {
      loading: false,
      tableLoading: false,
      filters: {
        appKey: { value: '' },
        messageResult: { value: '', precise: true },
        siteId: { value: '' },
        topic: { value: '' },
      },
      messageResults: [{
        value: true,
        label: '成功',
      }, {
        value: false,
        label: '失败',
      }],
      JobMessageHistoryList: [],
      total: 0,
      orderBy: '',
      selectColumn: 'appKey',
      translateMessageResult: {
        true: '成功',
        false: '失败',
      },
      multipleSelection: [],
    };
  },
  methods: {
    selectColumnChange() {
      this.filters.appKey.value = '';
      this.filters.siteId.value = '';
      this.filters.topic.value = '';
    },
    resetMessageResult() {
      this.filters.appKey.value = '';
      this.filters.siteId.value = '';
      this.filters.topic.value = '';
      this.filters.messageResult.value = '';
    },
    getJobMessageHistoryIdsArray(arr) {
      const jobMessageHistoryIdsArray = [];
      arr.forEach((ele) => {
        jobMessageHistoryIdsArray.push(ele.id);
      });
      return jobMessageHistoryIdsArray;
    },

    batchDelete() {
      this.batchOperation('删除', (arr) => {
        const selectedJobMessageHistoryArray = arr;
        if (selectedJobMessageHistoryArray.length === 0) {
          this.$message.errorMessage('没有可以删除的作业消息日志,请勾选!');
        } else {
          const confirmText = selectedJobMessageHistoryArray.length < 10 ? '确认删除作业消息日志吗?' : `确认删除已选的 ${selectedJobMessageHistoryArray.length} 条作业消息日志吗?`;
          this.$message.confirmMessage(confirmText, () => {
            const params = {
              jobMessageHistoryIds: this.getJobMessageHistoryIdsArray(selectedJobMessageHistoryArray).join(','),
            };
            this.$http.delete(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobMessageHistory/batchRemoveJobMessageHistory`, params).then(() => {
              this.refreshPage();
              this.$message.successNotify('批量删除作业消息日志操作成功');
            })
            .catch(() => { this.$http.buildErrorHandler('批量删除作业消息日志请求失败！'); });
          });
        }
      });
    },
    batchOperation(text, callback) {
      if (this.multipleSelection.length <= 0) {
        this.$message.errorMessage(`请选择要批量${text}的作业消息日志！！！`);
      } else {
        const selectedJobMessageHistoryArray = [];
        this.multipleSelection.forEach((element) => {
          selectedJobMessageHistoryArray.push(element);
        });
        callback(selectedJobMessageHistoryArray);
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete(row) {
      this.$message.confirmMessage('确认删除作业消息日志吗?', () => {
        const params = {
          jobMessageHistoryIds: row.id,
        };
        this.$http.delete(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobMessageHistory/batchRemoveJobMessageHistory`, params).then(() => {
          this.refreshPage();
          this.$message.successNotify('删除作业消息日志操作成功');
        })
        .catch(() => { this.$http.buildErrorHandler('删除作业消息日志请求失败！'); });
      });
    },
    getJobMessageHistory(params) {
      this.tableLoading = true;
      this.$http.get(`/console/namespaces/${this.domainName}/jobs/${this.jobName}/jobMessageHistory`, params).then((data) => {
        this.JobMessageHistoryList = data.jobMessageHistoryPage;
        this.total = data.totalCount;
      })
      .catch(() => { this.$http.buildErrorHandler('获取作业消息日志列表请求失败！'); })
      .finally(() => {
        this.tableLoading = false;
      });
    },
    refreshPage() {
      this.$refs.pageListRef.search();
    },
  },
  created() {
  },
  watch: {
    $route: 'init',
  },
  computed: {
    domainName() {
      return this.$route.params.domain;
    },
    jobName() {
      return this.$route.params.jobName;
    },
    filterColumnPlaceholder() {
      let str = '';
      switch (this.selectColumn) {
        case 'appKey':
          str = '请输入AppKey';
          break;
        case 'siteId':
          str = '请输入站点ID';
          break;
        case 'topic':
          str = '请输入消息主题';
          break;
        default:
          str = '';
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="sass" scoped>
.devicon-java-plain:before {
    content: "\F144";
}
</style>



// WEBPACK FOOTER //
// job_message_history.vue?3a567dea